import { FirmaGobernadora } from "./FirmaGobernadora";
import type { HeroRoom } from "../types";
import { useTitulo } from "../lib/useTitulo";

/**
 * Banda de cabecera de la sala.
 *
 * Medía 357 px en un viewport de 888 —el 40 % de la pantalla— y se repite en
 * once pantallas que se ven todos los días; hasta la primera materia había que
 * bajar el 64 %. Ahora ronda los 172 px. Lo que se quitó:
 *
 *   · el recuadro del icono (68 px + 16 de margen), que pintaba un dibujo
 *     encima de un titular que ya dice el nombre de la sala, en una pantalla a
 *     la que se llega desde un menú donde esa sala está marcada;
 *   · la fila de datos (`datos`), dos cajas translúcidas sobre la foto. No se
 *     pierde el dato: RoomPage lo pinta en la cabecera de la rejilla que cuenta,
 *     donde se lee como dato y no como adorno.
 *
 * La FOTO no se toca. Es la mejor pieza gráfica de la plataforma y sus velos
 * están medidos foto por foto en salas.css; ahí no hay nada que ahorrar.
 */
export function Hero({
  room,
  kicker,
  title,
  subtitle,
}: {
  room: HeroRoom;
  kicker: string;
  title: string;
  subtitle: string;
}) {
  // El titular de la sala es también el nombre de la pestaña: una sola fuente,
  // así las once pantallas con Hero quedan tituladas sin tocar cada una.
  useTitulo(title);
  return (
    <section className={`hero ${room}`}>
      <div className="kicker">{kicker}</div>
      <h1>{title}</h1>
      <p>{subtitle}</p>

      {/*
        Firma de la gobernadora en la esquina inferior derecha, pedida por la
        administración. Va la variante BLANCA y solo el trazo: encima de una
        fotografía no cabe un bloque con nombre y cargo.

        Sobre la legibilidad, que es el problema real de esta esquina: el velo de
        cada sala es horizontal y termina casi transparente a la derecha —está
        hecho así para que se vea la foto—, o sea que el blanco puede caer sobre
        una zona clara. Se resuelve con sombra propia sobre el trazo, no con un
        recuadro: un recuadro sobre la foto es exactamente lo que se quitó cuando
        murió la `info-card`. En móvil no hace falta, porque ahí el hero lleva
        encima un velo vertical que llega a 0.82 abajo.

        Con el hero a 172 px la firma NO se toca de tamaño: es requisito de la
        administración y encogerla para ganar aire sería ahorrar donde no toca.
        Lo que se ajusta es el tope de ancho del texto, para que el subtítulo no
        llegue a pisarla (ver `.hero p` en salas.css).
      */}
      <FirmaGobernadora soloTrazo variante="oscura" ancho={104} className="firma-hero" />
    </section>
  );
}
